import BaseRequest from './BaseRequest';

const schema = 'notify';
/**
 * key base on host:port
 */
export default class NotifyRequest extends BaseRequest {
  /**
	 * @param params
	 * @param {number} params.pos
	 * @param {number} params.count
	 * @returns {Promise<*|undefined>}
	 */
  fetchNotify(params) {
    const url = `${schema}/notifies`;
    return this.get(url, params);
  }
}
